import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Committee } from 'src/app/models/Committee';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';
import { ToastService } from 'src/app/util/toast.service';
import { CommitteeMember } from 'src/app/models/CommitteeMember';
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';
import { NotificationTriggerService } from '../notification-trigger.service';

@Injectable({
  providedIn: 'root',
})
export class CommitteeService {
  locationTypeList: string[] = ["country", "state", "district", "town", "area"];
  committeeNameList: string[] = ["President", "Vice President", "Treasurer", "Secretary", "Area Manager", "Assistant Manager", "Director", "Chief Financial Officer", "Legal Advisor", "Senior Advisor", "Honorary Chairperson"];
  committee: Committee = new Committee();
  committeeList: Committee[] = [];
  memberList: CommitteeMember[] = [];
  myMemberShip: CommitteeMember;
  // committeeList: Committee[] = [];

  constructor(private backEnd: BackEndService, private auth: AuthService, private toast: ToastService, private NotifyTR: NotificationTriggerService) {
    this.committee = new Committee();
  }

  getList(query) {
    return new Promise((resolve) => {

      this.backEnd.searchObject(appConfig.STORAGE_TABLE.COMMITTEE, query).then((committeeList: Committee[]) => {
        // for (let committee of committeeList) {
        //   if (committee.emp_json && ((typeof committee.emp_json === 'string'))) {
        //     committee.emp_json = JSON.parse(committee.emp_json);
        //   }
        // }
        this.committeeList = committeeList;
        resolve(committeeList);
      })
    })
  }
  getSingleCommittee(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.getSingle(appConfig.STORAGE_TABLE.COMMITTEE, [[variable, id]]).then((committee: Committee) => {
        // if (committee.emp_json && ((typeof committee.emp_json === 'string'))) {
        //   committee.emp_json = JSON.parse(committee.emp_json);
        // }
        this.committee = committee;
        resolve(true);
      })
    })
  }

  getMemberCount(id) {
    this.backEnd.countObject(appConfig.STORAGE_TABLE.COMMITTEE_MEMBER, [["committee_id", id]], "committee_id").then((count: any) => {
      if (this.committee.member_count != count[id]) {
        this.committee.member_count = count[id];
        this.backEnd.saveObject(appConfig.STORAGE_TABLE.COMMITTEE, this.committee);
      }
    })
  }


  saveObject() {
    return new Promise((resolve) => {
      this.committee.created_by = this.auth.loggedInEmployee.user.id;
      this.committee.business_id = this.auth.business.id;
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.COMMITTEE, this.committee).then((response) => {
        if (response) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  addCommitteeMember() {
    return new Promise((resolve) => {
      let newCm: CommitteeMember = new CommitteeMember();
      console.log("Adding Committee :", this.committee);
      newCm.committee_id = this.committee.id;
      newCm.emp_id = this.auth.loggedInEmployee.id;
      newCm.business_id = this.auth.loggedInEmployee.business_id;
      newCm.status = this.committee.member_count == null ? "Verified" : "Pending";
      newCm.dob = this.auth.loggedInEmployee.user.dob;
      newCm.role = this.committee.member_count == null ? "Admin" : null;
      newCm.profile_meta = {
        name: this.auth.loggedInEmployee.user.name,
        url: this.auth.loggedInEmployee.user.url,
        sub_community: this.auth.loggedInEmployee.user.user_pd.sub_community,
        current_address2: this.auth.loggedInEmployee.user.user_pd.current_address2,
        origin_city: this.auth.loggedInEmployee.user.user_pd.origin_city,
        gender: this.auth.loggedInEmployee.user.gender
      }
      console.log("New Committee Member:", newCm);
      this.saveCommitteeMember(newCm).then((response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(null);
        }
      });

    })
  }

  saveCommitteeMember(newCm) {
    return new Promise((resolve) => {
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.COMMITTEE_MEMBER, newCm).then((response) => {
        if (response) {
          resolve(newCm);
        } else {
          resolve(null);
        }
      });
    });
  }

  getCount(location, locationValue, groupLocation) {
    // (business_id_value, filter_column, filter_value, group_column)
    return new Promise((resolve) => {

      this.backEnd.rpcFunction('get_status_counts_by_location',
        {
          business_id_value: this.auth.business.id,
          filter_column: location,
          filter_value: locationValue,
          group_column: groupLocation
        }).then((res: any) => {
          console.log(res);
          if (res.body.data && res.body.data.length > 0) {
            resolve(res.body.data);
          }
        })
    })

  }

  deleteCommittee(id) {
    return new Promise((resolve) => {
      this.backEnd.deleteObject(appConfig.STORAGE_TABLE.COMMITTEE, id).then((response) => {
        if (response) {
          this.toast.success('Committee deleted successfully');
          resolve(true);
        } else {
          this.toast.success('Failed to delete committee');
          resolve(false);
        }
      });
    });
  }

  getCommitteeMember(query) {
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.COMMITTEE_MEMBER, query).then((committeeMemberList: CommitteeMember[]) => {
        if (committeeMemberList.length > 0) {
          let committeeMember = committeeMemberList[0];
          if (committeeMember && committeeMember.profile_meta && ((typeof committeeMember.profile_meta === 'string'))) {
            committeeMember.profile_meta = JSON.parse(committeeMember.profile_meta);
          }
          resolve(committeeMember);
        } else {
          resolve(null);
        }
      })
    })
  }
  getMemberList(query, localSave?: boolean) {
    if (localSave == null) {
      localSave = true;
    }
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.COMMITTEE_MEMBER, query).then((committeeMemberList: CommitteeMember[]) => {
        console.log(committeeMemberList);
        if (committeeMemberList) {
          for (let member of committeeMemberList) {
            if (member.profile_meta && ((typeof member.profile_meta === 'string'))) {
              member.profile_meta = JSON.parse(member.profile_meta);
            }
            if (member.meta && ((typeof member.meta === 'string'))) {
              member.meta = JSON.parse(member.meta);
            }
          }
          if (localSave) {
            this.memberList = committeeMemberList
            resolve(this.memberList);
          } else {
            resolve(committeeMemberList);
          }

        }

      })
    })
  }

  getMyMembership() {
    return new Promise((resolve) => {
      if (this.committee.id == null || this.auth.loggedInEmployee.id == null) {
        console.log("Committee ID or Employee ID is null");
        resolve(null);
      } else {
        this.backEnd.getSingle(appConfig.STORAGE_TABLE.COMMITTEE_MEMBER, [["committee_id", this.committee.id], ["emp_id", this.auth.loggedInEmployee.id]]).then((cm: CommitteeMember) => {
          if (cm.profile_meta && ((typeof cm.profile_meta === 'string'))) {
            cm.profile_meta = JSON.parse(cm.profile_meta);
          }
          if (cm.meta && ((typeof cm.meta === 'string'))) {
            cm.meta = JSON.parse(cm.meta);
          }
          this.myMemberShip = cm;
          console.log("My Membership:", this.myMemberShip);
          resolve(cm);
        })
      }
    })
  }
  getMyCommittees() {
    return new Promise((resolve) => {
      if (!this.auth.loggedInEmployee?.id) {
        resolve([]);
        return;
      }
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.COMMITTEE_MEMBER, [["emp_id", this.auth.loggedInEmployee.id]])
        .then((committeeMemberList: CommitteeMember[]) => {
          if (!committeeMemberList || committeeMemberList.length === 0) {
            resolve([]);
            return;
          }
          const committeeIds = committeeMemberList.map(cm => cm.committee_id);
          this.backEnd.searchObject(appConfig.STORAGE_TABLE.COMMITTEE, [["id", committeeIds]])
            .then((committees: Committee[]) => {
              resolve(committees);
              console.log("My Committees:", committees);
            });
        });
    });
  }
  sendReminder() {
    this.getCommitteeMember(
      [["committee_id", this.committee.id], ['role', 'Admin']]).then((admin: CommitteeMember) => {
        console.log("Committee Admin:", admin);
        if (admin) {
          let message = "Hello " + admin.profile_meta.name + " Ji,\n\n I have joined " + this.committee.name + " committee. Please Verify my details and Approve my request. For more information please contact me";
          this.NotifyTR.createAndSendNotification(
            "New Committee Member Joining Request",
            message,
            "committee_member_join",
            { committee_id: this.committee.id, emp_id: this.auth.loggedInEmployee.id }
          );
          console.log("Reminder sent to committee admin", this.committee.id, message);
        }
      })
  }
}
